import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import StlGenerator from './pages/StlGenerator';
import StlModels from './pages/StlModels';
import StlModelDetail from './pages/StlModelDetail';

function App() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Check for saved theme preference or default to 'dark'
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <Router>
      <div className={`app ${theme}-theme`} id="app-body">
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        <main className="container">
          <Routes>
            <Route path="/" element={<Home theme={theme} />} />
            <Route path="/about" element={<About theme={theme} />} />
            <Route path="/contact" element={<Contact theme={theme} />} />
            <Route path="/stl-generator" element={<StlGenerator theme={theme} />} />
            <Route path="/stl-models" element={<StlModels theme={theme} />} />
            <Route path="/stl-models/:id" element={<StlModelDetail theme={theme} />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
